import { FurnishedMarketAPI_Data, Homes_GET_RESPONSE } from '@sales-app/api/DisplayCity/DisplayCity'
import { Homes_API_Response } from '@sales-app/api/GeoLocation/GeoLocation'
import { Home } from '@sales-app/types/Home'

export function appendMarketPageData(data: Homes_GET_RESPONSE | undefined): { data: DisplayCityData } | undefined {
  if (!data) return

  const firstPage = data.data
  const hasFilters = !!firstPage.filters
  const defaultPageData = {
    ...firstPage,
    ...(hasFilters && {
      filters: {
        ...firstPage.filters,
        sorting: firstPage.filters.sorting,
      },
    }),
  }

  const marketHomes = appendHomeGroupsFromPages(data.data)
  delete defaultPageData.home_groups
  return { data: { ...defaultPageData, ...marketHomes } }
}

export function appendHomeGroupsFromPages(data: FurnishedMarketAPI_Data): MarketDataHomes {
  const mainHomesOfPage: Home[] = []
  const futureHomesOfPage: Home[] = []

  if (data.home_groups) {
    const { home_groups } = data
    home_groups.forEach((group) => {
      if (group.key === 'available_in_the_future' && group.homes) {
        futureHomesOfPage.push(...group.homes)
      } else {
        mainHomesOfPage.push(...group.homes)
      }
    })
  }

  return {
    homes: [...mainHomesOfPage],
    homes_available_in_future: [...futureHomesOfPage],
  }
}

export function appendGeoHomesDataToMarketData({
  geoHomesData,
  isWithinZoomBounds,
  displayCityData,
}: {
  displayCityData: Homes_GET_RESPONSE
  geoHomesData?: Homes_API_Response
  isWithinZoomBounds?: boolean
}) {
  const { current_page, home_groups, homes_count, total_homes, total_pages, ...displayCityDataWithoutHomes } =
    displayCityData?.data

  const noResults = {
    home_groups: [],
    current_page: 0,
    homes_count: 0,
    total_homes: 0,
    total_pages: 0,
    results_per_page: 0,
  }

  return {
    data: {
      ...displayCityDataWithoutHomes,
      ...((isWithinZoomBounds && geoHomesData?.data) || noResults),
    },
  }
}

export type DisplayCityData = Omit<FurnishedMarketAPI_Data, 'home_groups'> & MarketDataHomes

export interface MarketDataHomes {
  homes: Home[]
  homes_available_in_future: Home[]
}
